import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var GetCurrentSessionSupplantingDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "GetCurrentSessionSupplanting"
    },
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "security"
        },
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "current_session"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "session_type"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "session_key"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "session_data"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "session_user_id"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};

/**
 * __useGetCurrentSessionSupplantingQuery__
 *
 * To run a query within a React component, call `useGetCurrentSessionSupplantingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentSessionSupplantingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentSessionSupplantingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentSessionSupplantingQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(GetCurrentSessionSupplantingDocument, options);
}
export function useGetCurrentSessionSupplantingLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(GetCurrentSessionSupplantingDocument, options);
}